// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2s28S","approved":"Status_approved__1OZID","rejected":"Status_rejected__2kC-S","expired":"Status_expired__3mRs0","label":"Status_label__3Ht3D"};